import script from "./TabInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TabInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__